module.exports = __webpack_public_path__ + "img/digitalizacion.f80f0e74.jpg";